export const Mark = ({ className = "h-7 w-7", title }) => (
  <svg viewBox="220 236 584 580" className={className} role={title ? "img" : undefined} aria-hidden={title ? undefined : true} aria-label={title}>
    <path fill="#2E3CFD" className="dark:fill-[#5d68ff]" d="M512 246V340H325V665L430 560C455 537 485 527 512 527V620C500 621 492 626 486 632L330 785C318 797 305 805 290 805C258 805 232 780 232 748V330C232 284 270 246 316 246Z" />
    <path fill="#2E3CFD" className="dark:fill-[#5d68ff]" d="M512 340H718C759 340 792 373 792 414V640C792 681 759 714 718 714H512V620H697V434H512Z" />
  </svg>
);

export const Logo = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-2 ${className}`}>
    <Mark className="h-7 w-7" />
    <span className="font-display text-[1.45rem] font-bold leading-none tracking-[-0.04em] text-foreground">
      chatplate<sup className="ml-0.5 text-[0.5rem] font-medium align-super">®</sup>
    </span>
  </span>
);
